export type SseEventHandler = (event: string, data: unknown) => void;

function parseSseBlock(block: string): { event: string; data: unknown } | null {
  let event = 'message';
  let data = '';
  for (const line of block.split('\n')) {
    if (line.startsWith('event:')) event = line.slice(6).trim();
    else if (line.startsWith('data:')) data += (data ? '\n' : '') + line.slice(5).trim();
  }
  if (!data) return null;
  try {
    return { event, data: JSON.parse(data) };
  } catch {
    return null;
  }
}

// Reads Server-Sent Events from a fetch body until it closes. Comment lines (": ping") and blocks
// without JSON data are skipped. Throws what the reader throws, such as an AbortError.
export async function readSseStream(
  body: ReadableStream<Uint8Array>,
  onEvent: SseEventHandler,
): Promise<{ sawDone: boolean }> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let sawDone = false;

  try {
    for (;;) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });

      let end;
      while ((end = buffer.indexOf('\n\n')) >= 0) {
        const parsed = parseSseBlock(buffer.slice(0, end));
        buffer = buffer.slice(end + 2);
        if (!parsed) continue;
        if (parsed.event === 'done') sawDone = true;
        onEvent(parsed.event, parsed.data);
      }
    }
  } finally {
    try {
      reader.releaseLock();
    } catch {
      // already released
    }
  }

  return { sawDone };
}
